
export const isAdmin = () => {
  if (localStorage.getItem("APN_USERTYPE") == process.env.REACT_APP_ADMIN_ROLE || 
                localStorage.getItem("APN_USERTYPE") == process.env.REACT_APP_PM_ROLE)
    return true;
  else
    return false;
};

export const ADMIN_ROOT_URL = "/projects";
export const FIELDWORKER_ROOT_URL = "/callform";


// WEBPACK FOOTER //
// ./src/lib/users.js